/**
 * Created by r4zi4l on 19.01.2021
 */

const BuyIngredientsWindow = CleverappsWindow.extend({
    onWindowLoaded: function (shoppingList, onSuccess, orders) {
        this.ingredients = shoppingList.softItems.concat(shoppingList.hardItems);
        this.onSuccess = onSuccess || function () {};
        this.shoppingList = shoppingList;
        this.orders = orders;

        this._super({
            title: Messages.get("BuyIngredientsWindow.title"),
            name: "BuyIngredientsWindow",
            content: this.createContent(),
            buttons: this.createButton(),
            closeButton: true
        });

        cleverapps.focusManager.showControlsWhileFocused("MenuBarGoldItem");
    },

    onClose: function () {
        cleverapps.focusManager.hideControlsWhileFocused("MenuBarGoldItem");
    },

    createContent: function () {
        const styles = cleverapps.styles.BuyIngredientsWindow;

        const icons = this.ingredients.map(function (ingredient) {
            return this.createTile(ingredient);
        }, this);

        const iconsLayout = new cleverapps.Layout(icons, {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.tiles.margin
        });

        const question = cleverapps.UI.generateOnlyText(Messages.get("BuyIngredientsWindow.text"), cleverapps.styles.FONTS.DARK_TEXT);
        question.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        question.setDimensions(styles.question.width, styles.question.height);
        return new cleverapps.Layout([question, iconsLayout], {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.margin
        });
    },

    createTile: function (ingredient) {
        const styles = cleverapps.styles.BuyIngredientsWindow.tile;

        const tile = new cc.Node();
        tile.setContentSize2(styles.background);

        const background = cleverapps.UI.createScale9Sprite(bundles.windows.frames.tile_bg_png);
        background.setContentSize2(styles.background);
        background.setAlignment(styles.background);
        tile.addChild(background);

        const amountBackground = cleverapps.UI.createScale9Sprite(bundles.windows.frames.tile_amount_png);
        amountBackground.setContentSize2(styles.amountBackground);
        amountBackground.setAlignment(styles.amountBackground);
        tile.addChild(amountBackground);

        const amountText = cleverapps.UI.generateImageText(`x${ingredient.amount}`, cleverapps.styles.FONTS.BUYINGREDIENTSWINDOW_AMOUNT);
        amountText.setAlignment(styles.amountText);
        amountText.fitTo(styles.amountText.width);
        tile.addChild(amountText);

        const icon = CustomerRecipe.getIngredientIcon(ingredient);
        icon.setAnchorPoint(0.5, 0.5);
        icon.setAlignment(styles.icon);
        icon.setScale(styles.icon.scale);
        tile.addChild(icon);

        const title = cleverapps.UI.generateOnlyText(CustomerRecipe.getIngredientName(ingredient), cleverapps.styles.FONTS.BUYINGREDIENTSWINDOW_TITLE);
        title.setAnchorPoint(0.5, 0.5);
        title.setAlignment(styles.title);
        title.fitTo(styles.title.width);
        tile.addChild(title);

        if (!cleverapps.meta.getSelectedLocation().locationConfig.isMain) {
            const help = new cleverapps.UI.HelpButton({
                callback: this.findIngredient.bind(this, ingredient)
            });
            tile.addChild(help);
            help.setAlignment(styles.help);
        }

        return tile;
    },

    createButton: function () {
        const styles = cleverapps.styles.BuyIngredientsWindow.button;

        const totalHard = this.shoppingList.totalHard, totalSoft = this.shoppingList.totalSoft;
        const msg = (totalSoft ? ` @@${totalSoft}` : "") + (totalHard ? ` $$${totalHard}` : "");

        return new cleverapps.UI.Button({
            type: cleverapps.styles.UI.Button.Images.button_green,
            text: msg,
            width: styles.width,
            height: styles.height,
            eventName: cleverapps.EVENTS.SPENT.INGREDIENT,
            onClicked: function () {
                this.orders.buyIngredients(this.shoppingList, () => {
                    this.onSuccess();
                    this.close();
                });
            }.bind(this)
        });
    },

    findIngredient: function (ingredient) {
        const target = BuyIngredientsWindow.findIngredientSource(ingredient.ingredient || ingredient.unit.code);
        if (!target) {
            cleverapps.notification.create(Messages.get("Quest.find.empty"));
            return;
        }

        const windowComponent = ComponentMap.get(this, WindowComponent);
        windowComponent.hideWindow();
        FingerView.hintTap({ x: target.x, y: target.y }, { runOnce: true });
        Map2d.currentMap.focusOnUnit(target, {
            allowScrollWithFocus: true,
            delay: 1,
            callback: () => {
                windowComponent.displayWindow();
            }
        });
    }
});

BuyIngredientsWindow.findIngredientSource = function (code) {
    const resources = [];
    const mineables = [];
    const chests = [];
    const shops = [];

    const units = Map2d.currentMap.listAvailableUnits();
    units.forEach((unit) => {
        if (unit.code === code) {
            resources.push(unit);
            return;
        }

        const mineable = unit.findComponent(Mineable);
        if (mineable) {
            mineables.push(mineable);
            return;
        }

        const chest = unit.findComponent(Chest);
        if (chest) {
            chests.push(chest);
            return;
        }

        const shop = unit.findComponent(UnitsShopComponent);
        if (shop) {
            shops.push(shop);
        }
    });

    const center = Map2d.currentMap.getScreenCenterCell();
    const comparator = function (a, b) {
        return cc.getDistanceChebyshev(a.unit || a, center) - cc.getDistanceChebyshev(b.unit || b, center);
    };

    resources.sort(comparator);
    if (resources.length) {
        return resources[0];
    }

    mineables.sort(comparator);
    for (let i = 0; i < mineables.length; ++i) {
        if (mineables[i].listAvailablePrizes().some((prize) => prize && (prize.code === code || prize.ingredient === code))) {
            return mineables[i].unit;
        }
    }

    chests.sort(comparator);
    for (let i = 0; i < chests.length; ++i) {
        if (!cleverapps.flags.fixedChests && Chest.ListPrizeProb(chests[i].unit).types.some((prize) => prize && (prize.code === code || prize.ingredient === code))) {
            return chests[i].unit;
        }
    }

    shops.sort(comparator);
    for (let i = 0; i < shops.length; ++i) {
        if (cleverapps.unitsShop.tabs[shops[i].tab].generateProducts().some((prize) => prize && prize.unit && prize.unit.code === code)) {
            return shops[i].unit;
        }
    }
};

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    BUYINGREDIENTSWINDOW_AMOUNT: {
        size: 60,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },

    BUYINGREDIENTSWINDOW_TITLE: {
        name: "nostroke",
        size: 45,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    }
});

cleverapps.styles.BuyIngredientsWindow = {
    margin: 40,

    icons: {
        margin: 20
    },

    button: {
        width: 300,
        height: 110
    },

    question: {
        width: 800,
        height: 100
    },

    tiles: {
        margin: 60
    },

    tile: {
        background: {
            width: 280,
            height: 450,
            x: { align: "center" },
            y: { align: "center" }
        },

        amountBackground: {
            width: 330,
            height: 115,
            x: { align: "center", dx: 13 },
            y: { align: "center", dy: -80 }
        },

        amountText: {
            x: { align: "center" },
            y: { align: "center", dy: -68 },
            width: 320
        },

        icon: {
            x: { align: "center" },
            y: { align: "center", dy: 75 },
            scale: 1.6
        },

        title: {
            width: 260,
            x: { align: "center" },
            y: { align: "center", dy: -170 }
        },

        help: {
            x: { align: "top", dx: -10 },
            y: { align: "right", dy: -10 }
        }
    }
};
